import { ApiAccountSnapshot } from 'api/rtk-api'
import ArrowsCompareIcon from 'assets/arrows-compare.svg?react'
import PieChartIcon from 'assets/pie-chart.svg?react'
import MenuIcon from 'assets/trade.svg?react'
import { Statistic } from 'components/core-v2'
import { Currency, formatCurrencyFull } from 'utilities/currency'

import classes from './index.module.scss'

export const TradeEventsStatistics = ({ snapshot }: { snapshot: ApiAccountSnapshot }) => {
  const {
    accountValue,
    notionalCurrency,
    pendingPerformanceAllocation,
    pendingProtectionAllocation,
    performanceAllocation = 0,
    protectionAllocation = 0
  } = snapshot
  const currency = notionalCurrency as Currency
  const inflightOrders = pendingPerformanceAllocation + pendingProtectionAllocation || 0

  const defaultCash = snapshot.currencyHoldings.reduce((acc, holding) => holding.value, 0)
  const cash = snapshot.cashAllocation ?? defaultCash

  const defaultLoan = snapshot.loanHoldings.reduce((acc, holding) => holding.value + acc, 0)
  const loanAmount = snapshot.loanAllocation || defaultLoan
  return (
    <>
      <div className={classes.statSection}>
        <div className={classes.heading}>
          <MenuIcon />
          <h3>Overview</h3>
        </div>
        <Statistic.Wrapper>
          <Statistic.Header>Total account value</Statistic.Header>
          <Statistic.Stat>{formatCurrencyFull(accountValue, currency)}</Statistic.Stat>
        </Statistic.Wrapper>
        <Statistic.Wrapper>
          <Statistic.Header>Inflight orders</Statistic.Header>
          <Statistic.Stat>{formatCurrencyFull(inflightOrders, currency)}</Statistic.Stat>
        </Statistic.Wrapper>
      </div>

      <div className={classes.statSection}>
        <div className={classes.heading}>
          <PieChartIcon />
          <h3>Assets</h3>
        </div>
        <Statistic.Wrapper>
          <Statistic.Header>Performance</Statistic.Header>
          <Statistic.Stat>{formatCurrencyFull(performanceAllocation, currency)}</Statistic.Stat>
        </Statistic.Wrapper>

        <Statistic.Wrapper>
          <Statistic.Header>Protection</Statistic.Header>
          <Statistic.Stat>{formatCurrencyFull(protectionAllocation, currency)}</Statistic.Stat>
        </Statistic.Wrapper>
      </div>

      <div className={classes.statSection}>
        <div className={classes.heading}>
          <ArrowsCompareIcon />
          <h3>Clearing provision</h3>
        </div>
        <Statistic.Wrapper>
          <Statistic.Header>Cash</Statistic.Header>
          <Statistic.Stat>{formatCurrencyFull(cash, currency)}</Statistic.Stat>
        </Statistic.Wrapper>
        <Statistic.Wrapper>
          <Statistic.Header>Leverage amount</Statistic.Header>
          <Statistic.Stat>{formatCurrencyFull(loanAmount, currency)}</Statistic.Stat>
        </Statistic.Wrapper>
      </div>
    </>
  )
}
